/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ExamEditorViewModel } from "../types/ExamEditorViewModel.ts";

export const examEditorViewModelSchema = z.object({
  title: z.string().describe("Título da prova.").nullish(),
  disciplineId: z
    .number()
    .int()
    .describe("ID da disciplina associada à prova. Opcional.")
    .nullish(),
  randomize: z.optional(
    z
      .boolean()
      .describe("Define se as questões serão embaralhadas para cada aluno."),
  ),
  questionsQuantity: z
    .number()
    .int()
    .describe(
      "Quantidade de questões exibidas ao aluno. Utilizado em conjunto com 'randomize = true'. Opcional.",
    )
    .nullish(),
  gradeCriteria: z.optional(
    z
      .number()
      .int()
      .describe(
        "Critério utilizado para apuração da nota final do aluno. Enum EExamGradeCriteria: `1` = Last, `2` = Highest.",
      ),
  ),
  examType: z.optional(
    z
      .number()
      .int()
      .describe(
        "Tipo da prova. Enum EExamType: `0` = StudentEvaluation, `1` = TeacherEvaluation, `2` = InstructorEvaluation, `3` = MonographQuestionnaire, `4` = Challenge, `5` = Qualification, `6` = Scholarship, `7` = Entrance.",
      ),
  ),
  examReferenceShow: z.optional(
    z
      .number()
      .int()
      .describe(
        "Define a exibição do gabarito durante a realização da prova. Enum EExamReferenceShow: `1` = None, `2` = Partial, `3` = Total.",
      ),
  ),
  examReferenceShowPost: z.optional(
    z
      .number()
      .int()
      .describe(
        "Define a exibição do gabarito após a entrega/conclusão da prova. Enum EExamReferenceShow: `1` = None, `2` = Partial, `3` = Total.",
      ),
  ),
  showAnswersTries: z.optional(
    z
      .boolean()
      .describe(
        "Define se as tentativas de resposta anteriores do aluno serão exibidas.",
      ),
  ),
  weight: z.optional(
    z
      .number()
      .int()
      .describe("Peso da prova no cálculo da média final do aluno."),
  ),
  percentualComplexity: z.optional(
    z
      .number()
      .int()
      .describe("Percentual de complexidade da prova. Valor entre 0 e 100."),
  ),
  companyId: z
    .number()
    .int()
    .describe("ID da empresa à qual a prova pertence. Opcional.")
    .nullish(),
  recommendedToDoOnPortal: z.optional(
    z
      .boolean()
      .describe(
        "Indica se a prova é recomendada para ser realizada diretamente no portal.",
      ),
  ),
  enableBlockUnauthorizedActions: z.optional(
    z
      .boolean()
      .describe(
        "Habilita o bloqueio de ações não autorizadas durante a realização da prova (ex: copiar, colar).",
      ),
  ),
  enableSafeEvaluationMode: z.optional(
    z
      .boolean()
      .describe(
        "Habilita o modo de avaliação segura, monitorando saídas de tela durante a prova.",
      ),
  ),
  maxScreenExitsAllowed: z
    .number()
    .int()
    .describe(
      "Número máximo de saídas de tela permitidas quando o modo de avaliação segura está ativo. Opcional.",
    )
    .nullish(),
  instruction: z
    .string()
    .describe(
      "Instrução ou enunciado exibido ao aluno antes do início da prova.",
    )
    .nullish(),
}) as unknown as ToZod<ExamEditorViewModel>;
